import invitations from './invitations'
import residents from './residents'
import activeIntegrations from './activeIntegrations'
import integrations from './integrations'
import apiKeys from './apiKeys'

import { Tenant } from "@/state/Tenant";

import { TenantRoutes, ExchangeRateRoutes, ReportRoutes } from '@/repository/tenant';
const { UpdateTenantArena, UpdateTenantAppearance, UpdateTenantData } = TenantRoutes;
const { ExchangeRates } = ExchangeRateRoutes;


export default {
	namespaced: true,
	state: {
		current: Tenant.stateDefaults(),
		_current: new Tenant(),
	},
	modules: {
		invitations,
		residents,
		activeIntegrations,
		integrations,
		apiKeys
	},
	actions: {
		async UpdateArena({ commit }, data) {
			try {
				let res = await UpdateTenantArena(data)
				commit('SET_CURRENT_TENANT', res.data);
				this.commit('auth/user/SET_CURRENT_USER', { current_tenant: res.data });
				return res
			}
			catch (error) {
				console.error('Tenant arena could not be updated.', error);
				throw error;
			}
		},
		async UpdateAppearance({ commit }, data) {
			try {
				let res = await UpdateTenantAppearance(data)
				commit('SET_CURRENT_TENANT', res.data);
				this.commit('auth/user/SET_CURRENT_USER', { current_tenant: res.data });
				return res
			}
			catch (error) {
				console.error('Tenant appearance could not be updated.', error);
				throw error;
			}
		},
		async UpdateData({ commit }, data) {
			try {
				let res = await UpdateTenantData(data)
				commit('SET_CURRENT_TENANT', res.data);
				this.commit('auth/user/SET_CURRENT_USER', { current_tenant: res.data });
				return res
			}
			catch (error) {
				console.error('Tenant appearance could not be updated.', error);
				throw error;
			}
		},
		async GetExchangeRates({ commit }, data) {
			try {
				let res = await ExchangeRates();
				return res.data;
			} catch (error) {
				console.error('Cannot retrieve current exchange rates.', error);
				throw error;
			}
		}

	},
	mutations: {
		SET_CURRENT_TENANT(state, obj) {
			state.current = state._current.commit(obj)
		},
	}
}